import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  constructor(
    private snackBar: MatSnackBar,
    private translateService: TranslateService
  ) {}

  private get defaultConfig(): MatSnackBarConfig {
    const config = new MatSnackBarConfig();

    config.verticalPosition = 'top';
    config.horizontalPosition = 'center';
    config.duration = 3000;

    return config;
  }

  public success(message: string, parameters: Object = {}): void {
    const config = this.defaultConfig;
    config.panelClass = 'success-snackbar';
      
    this.open(message, parameters, config);
  }

  public error(message: string, parameters: Object = {}): void {
    const config = this.defaultConfig;
    config.panelClass = 'error-snackbar';
    config.duration = 5000;

    this.open(message, parameters, config);
  }

  private open(message: string, parameters: Object, config: MatSnackBarConfig): void {
    this.snackBar.open(this.translateService.instant(message, parameters), undefined, config);
  }
}
